const s = {
  name: "Casette",
  dimensions: { width: 40, height: 28 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 28" style="enable-background:new 0 0 40 28;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M6.2,5c0,0.7-0.6,1.2-1.2,1.2S3.8,5.7,3.8,5S4.3,3.8,5,3.8S6.2,4.3,6.2,5z"/>
		<path class="st0" d="M35,6.3c0.7,0,1.2-0.6,1.2-1.2S35.7,3.8,35,3.8S33.8,4.3,33.8,5S34.3,6.3,35,6.3z"/>
		<path class="st0" d="M6.2,23c0,0.7-0.6,1.2-1.2,1.2S3.8,23.7,3.8,23c0-0.7,0.6-1.2,1.2-1.2S6.2,22.3,6.2,23z"/>
		<path class="st0" d="M35,24.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2s-1.2,0.6-1.2,1.2C33.8,23.7,34.3,24.2,35,24.2z"/>
		<path class="st0" d="M29,18H11c-2.2,0-4-1.8-4-4s1.8-4,4-4h18c2.2,0,4,1.8,4,4S31.2,18,29,18z M11,12c-1.1,0-2,0.9-2,2s0.9,2,2,2
			c1.1,0,2-0.9,2-2S12.1,12,11,12z M25.5,16c-0.3-0.6-0.5-1.3-0.5-2c0-0.7,0.2-1.4,0.5-2H14.5c0.3,0.6,0.5,1.3,0.5,2
			c0,0.7-0.2,1.4-0.5,2H25.5z M29,16c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2S27.9,16,29,16z"/>
		<path class="st0" d="M11,7h18V5H11V7z"/>
		<path class="st0" d="M3,28c-1.7,0-3-1.3-3-3V3c0-1.7,1.3-3,3-3h34c1.7,0,3,1.3,3,3v22c0,1.7-1.3,3-3,3H3z M2,3v22c0,0.6,0.4,1,1,1
			h5.3l2-5h19.4l2,5H37c0.6,0,1-0.4,1-1V3c0-0.6-0.4-1-1-1H3C2.4,2,2,2.4,2,3z M10.5,26h19l-1.2-3H11.7L10.5,26z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Casette
};
